import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MERCARI_CONDITIONS } from "@/pages/vinted/mercariOptions";

const label = "text-[10px] font-mono uppercase tracking-wider text-slate-500";

function Chips({ value, options, onChange, testid }) {
  return (
    <div className="mt-1 flex flex-wrap gap-1.5" data-testid={testid}>
      {options.map(([k, t]) => (
        <button key={k || "auto"} type="button" onClick={() => onChange(k)} aria-pressed={value === k} data-testid={`${testid}-${k || "auto"}`}
          className={`h-8 flex-1 whitespace-nowrap rounded-full border px-2.5 text-[11px] font-semibold transition-colors ${value === k ? "border-[#f26222] bg-[#f26222] text-white" : "border-slate-200 bg-white text-slate-600 hover:border-[#f26222]"}`}>{t}</button>
      ))}
    </div>
  );
}

// Everything the extension picks on Mercari's sell form. Blank = SnapList's default.
export default function MercariFields({ draft, value, onChange }) {
  const [auto, setAuto] = useState(null);
  const m = value || {};
  useEffect(() => { api.get(`/paste/mercari/${draft.id}`).then(({ data }) => setAuto(data)).catch(() => setAuto({})); }, [draft.id, draft.condition, draft.package?.weight_lb, draft.package?.weight_oz]);
  const set = (k, v) => onChange({ ...m, [k]: v });
  const brand = (draft.item_specifics || []).find((s) => /^brand$/i.test(s.key || ""))?.value;
  const payer = m.payer || "seller"; const method = m.method || "own";
  return (
    <div className="rounded-lg border border-[#f26222]/40 bg-[#f26222]/5 p-3" data-testid="mercari-fields">
      <p className="text-xs font-semibold uppercase tracking-wider text-[#c2410c]">Mercari listing</p>
      <p className="mt-1 text-[11px] text-slate-600" data-testid="mercari-summary">
        Category <b>{(draft.category || "").split(">").pop().trim() || "not set"}</b> · Brand <b>{brand || "skipped"}</b> · Weight <b>{auto?.weight || "not set"}</b> · Price <b>{draft.price ? `$${draft.price}` : "not set"}</b>
      </p>
      <label className="mt-2 block"><span className={label}>Condition</span>
        <select value={m.condition || ""} onChange={(e) => set("condition", e.target.value)} data-testid="mercari-condition"
          className="mt-1 h-8 w-full rounded-md border border-slate-300 bg-white px-2 text-xs text-slate-800">
          <option value="">{auto?.auto?.condition ? `Auto · ${auto.auto.condition}` : "Auto"}</option>
          {MERCARI_CONDITIONS.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </label>
      <p className={`${label} mt-2`}>Shipping</p>
      <Chips value={payer} onChange={(k) => set("payer", k)} options={[["seller", "Free shipping (I pay)"], ["buyer", "Buyer pays"]]} testid="mercari-payer" />
      <Chips value={method} onChange={(k) => set("method", k)} options={[["own", "Ship on your own"], ["label", "Mercari label"]]} testid="mercari-method" />
      <p className={`${label} mt-2`}>Will it fit in a 14 x 10 x 5 in box?</p>
      <Chips value={m.box_fit || ""} onChange={(k) => set("box_fit", k)} options={[["yes", "Yes"], ["no", "No"], ["", "Skip"]]} testid="mercari-box-fit" />
      <p className="mt-1.5 text-[10px] text-slate-500">The extension adds the photos, then fills title, description, category, brand, condition, shipping, weight, the box answer and price on Mercari, and presses List (switch it off in the extension to press List yourself).</p>
    </div>
  );
}
